import {
  Component,
  OnDestroy,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-documentstable",
  templateUrl: "documentstable.component.html",
})
export class DocumentsTableComponent implements OnDestroy, OnInit {
  @ViewChild("template", { static: true }) template;
  @Input() data: any;
  @Output() documentOpened: EventEmitter<number> = new EventEmitter();
  subs = new SubSink();
  cssColor: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  opendocument(documentId) {
    this.documentOpened.emit(documentId);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
